import { CollectionPoint } from '@witkac/kartamiejska-shared';
import { collectionPointResource, CollectionPointResource } from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';

/**
 * Moduł punktów odbioru
 *
 * @export
 * @class CollectionPointModule
 * @extends {EntityModule<CollectionPoint, CollectionPointResource>}
 */
export class CollectionPointModule extends EntityModule<CollectionPoint, CollectionPointResource> {
  constructor() {
    super(collectionPointResource);
  }
}

export default new CollectionPointModule();
